import React, { useState } from "react";
import { Palette, ArrowRight, Check } from "lucide-react";
import { roofColors } from "../mock";
import { TaktvattBooking } from "./TaktvattBooking";

export default function RoofColorVisualizer({ compact }) {
  const [sel, setSel] = useState(roofColors[0].id);
  const active = roofColors.find((c) => c.id === sel);

  return (
    <section id="takfargvaljare" className="bg-[#0b1220] py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="reveal max-w-2xl">
          <p className="flex items-center gap-2 text-sm font-bold uppercase tracking-[0.15em] text-[#38BDF8]">
            <Palette className="w-4 h-4" /> Takfärgväljare
          </p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-white">Se ditt nya tak innan vi målar</h2>
          <p className="mt-4 text-slate-300 text-lg">Välj en takfärg och se direkt hur resultatet kan bli. Boka takmålning med din favoritfärg – vi hjälper dig hela vägen.</p>
        </div>

        <div className="reveal mt-10 grid lg:grid-cols-[1.4fr_1fr] gap-8 items-center">
          {/* House preview */}
          <div className="relative overflow-hidden rounded-3xl ring-1 ring-white/10 shadow-2xl">
            {roofColors.map((c) => (
              <img
                key={c.id}
                src={c.img}
                alt={`Hus med takfärg ${c.label}`}
                data-testid={`roof-preview-${c.id}`}
                className={`w-full aspect-[3/2] object-cover transition-opacity duration-500 ${c.id === sel ? "opacity-100" : "opacity-0 absolute inset-0"}`}
                loading="lazy"
              />
            ))}
            <div className="absolute bottom-4 left-4 rounded-full bg-black/60 backdrop-blur px-4 py-2 text-sm font-semibold text-white" data-testid="roof-active-label">
              {active.label}
            </div>
          </div>

          {/* Color picker */}
          <div>
            <p className="text-sm font-bold text-white">Välj din nya takfärg</p>
            <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-3">
              {roofColors.map((c) => (
                <button
                  key={c.id}
                  onClick={() => setSel(c.id)}
                  data-testid={`roof-swatch-${c.id}`}
                  className={`group flex flex-col items-center gap-2 rounded-2xl p-3 transition-all ${c.id === sel ? "bg-white/10 ring-2 ring-[#38BDF8]" : "ring-1 ring-white/10 hover:bg-white/5"}`}
                >
                  <span className="relative flex h-14 w-14 items-center justify-center rounded-full ring-2 ring-white/20" style={{ backgroundColor: c.hex }}>
                    {c.id === sel && <Check className="w-6 h-6 text-white drop-shadow" />}
                  </span>
                  <span className={`text-xs font-semibold ${c.id === sel ? "text-white" : "text-slate-300"}`}>{c.label}</span>
                </button>
              ))}
            </div>

            <div className="mt-6 rounded-2xl bg-white/5 ring-1 ring-white/10 p-5">
              <p className="text-sm text-slate-300">Vald takfärg</p>
              <p className="mt-1 text-2xl font-extrabold text-white" data-testid="roof-selected-name">{active.label}</p>
              <TaktvattBooking
                serviceLabel="Takmålning"
                details={`Vald takfärg: ${active.label}`}
                priceText="från 26 600 kr efter ROT"
                dayLong
                triggerLabel={`Boka takmålning i ${active.label}`}
                triggerClassName="mt-4 w-full rounded-full h-12 bg-[#38BDF8] text-[#062a4f] hover:bg-[#7dd3fc] font-bold"
              />
              <p className="mt-2 text-center text-xs text-slate-400">Fri besiktning · betala först när jobbet är klart</p>
            </div>
          </div>
        </div>

        {!compact && (
          <a href="/takmalning" className="reveal mt-8 inline-flex items-center gap-1.5 text-sm font-semibold text-[#38BDF8] hover:underline">
            Läs mer om takmålning <ArrowRight className="w-4 h-4" />
          </a>
        )}
      </div>
    </section>
  );
}
